import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, formatError } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("vincebenz@gmail.com");
  const [password, setPassword] = useState("TableGather2026!");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back");
      nav("/");
    } catch (err) {
      toast.error(formatError(err));
    } finally { setLoading(false); }
  };
  return (
    <div className="min-h-screen grid place-items-center bg-background p-4">
      <Card className="w-full max-w-md p-8">
        <div className="flex flex-col items-center text-center mb-6">
          <img
            src="/images/login-hero.png"
            alt="The Common Dinner — find a dinner that works for everyone"
            data-testid="login-hero-image"
            className="w-56 h-56 object-contain"
            loading="eager"
          />
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" data-testid="login-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} required />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" data-testid="login-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} required />
          </div>
          <Button type="submit" data-testid="login-submit-btn" disabled={loading} className="w-full">
            {loading ? "Signing in…" : "Sign in"}
          </Button>
          <div className="flex justify-between text-sm">
            <Link data-testid="login-forgot-link" to="/forgot-password" className="text-muted-foreground hover:text-foreground">Forgot password?</Link>
            <Link data-testid="login-register-link" to="/register" className="text-muted-foreground hover:text-foreground">Create account</Link>
          </div>
        </form>
      </Card>
    </div>
  );
}
